module.exports = __webpack_public_path__ + "static/media/add fees type.db84f549.svg";